import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(DrawSVGPlugin, ScrollToPlugin);

const profileCarousel = () => {
  const profiles = document.querySelector('.squad__carousel');
  if (!profiles) return;
  gsap.set(profiles, { opacity: 0 });
  gsap.to(profiles, { opacity: 1, duration: 2 });
};

const profiles = () => {
  const profiles = gsap.utils.toArray('.squad__profile-content');
  if (profiles <= 0) {
    return;
  }

  profiles.forEach((profile) => {
    gsap.set(profile, { opacity: 0, y: 60 });
    gsap.to(profile, {
      scrollTrigger: {
        start: 'top 90%',
        trigger: profile,
        scrub: true,
      },
      duration: 1,
      opacity: 1,
    });
  });

  const svgLoops = gsap.utils.toArray('.loop-svg path');
  if (!svgLoops) {
    return;
  }
  svgLoops.forEach((loop) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        start: 'top 70%',
        trigger: loop,
        scrub: true,
      },
    });
    tl.fromTo(loop, { drawSVG: '100% 100%' }, { drawSVG: '0% 100%' }, 0);
  });

  const statement = document.querySelector('.squad__statement');
  gsap.set(statement, { opacity: 0, y: 60 });
  gsap.to(statement, {
    scrollTrigger: {
      start: 'top 90%',
      trigger: statement,
      scrub: true,
    },
    duration: 1,
    opacity: 1,
    y: 0,
  });

  //  Scroll to Profiles //

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-name]')) return;
    const name = e.target.closest('[data-name]').dataset.name;
    const target = '[data-target="' + name + '"]';
    gsap.to(window, { duration: 2, scrollTo: target });
  });

  // Reveal Squad Photos //
  gsap.to('.profiles', { y: -80 });
};

export const squadAnimations = () => {
  profiles();
  profileCarousel();
};
